export default class FeaturesEnum {
    static get ADYEN() {
        return 'ADYEN';
    }

    static get MULTI_MENU() {
        return 'MULTI_MENU';
    }

    static get INTERNAL() {
        return 'INTERNAL';
    }

    static get ITEM_IDS() {
        return 'ITEM_IDS';
    }

    static get CENTEGRA() {
        return 'CENTEGRA';
    }

    static get IKENTOO() {
        return 'IKENTOO';
    }

    static get IKENTOO_BETA() {
        return 'IKENTOO_BETA';
    }

    static get COMTREX() {
        return 'COMTREX';
    }

    static get MAILCHIMP() {
        return 'MAILCHIMP';
    }

    static get PAT() {
        return 'PAT';
    }

    static get TOGGLE() {
        return 'TOGGLE';
    }

    static get SAAS() {
        return 'SAAS';
    }

    static get CATEGORY_IMAGE() {
        return 'CATEGORY_IMAGE';
    }

    static get LOYALTY() {
        return 'LOYALTY';
    }

    static get OPENTABLE() {
        return 'OPENTABLE';
    }

    static get FRESHKDS() {
        return 'FRESHKDS';
    }

    static get TISSL() {
        return 'TISSL';
    }

    static get AUTO_APPLY() {
        return 'AUTO_APPLY';
    }

    static get ZONAL() {
        return 'ZONAL';
    }

    static get CATERING() {
        return 'CATERING';
    }

    static get INVOICE() {
        return 'INVOICE';
    }

    static get BAKERY() {
        return 'BAKERY';
    }

    static get TRANSLATION_EDITOR() {
        return 'TRANSLATION_EDITOR';
    }

    static get STORE_DESIGNER() {
        return 'STORE_DESIGNER';
    }

    static get MEGA_MENU() {
        return 'MEGA_MENU';
    }

    static get DITTOFEED() {
        return 'DITTOFEED';
    }

    static get TRANSLATION_OVERRIDES() {
        return 'TRANSLATION_OVERRIDES';
    }

    static get UBER_DIRECT() {
        return 'UBER_DIRECT';
    }

    static get POINT_ONE() {
        return 'POINT_ONE';
    }

    static get AUTOMATIONS() {
        return 'AUTOMATIONS';
    }

    static get COURSING() {
        return 'COURSING';
    }

    static get PLU() {
        return 'PLU';
    }

    static get API_KEYS() {
        return 'API_KEYS'
    }

    static get VAT_NUMBER() {
        return 'VAT_NUMBER';
    }

    static get OLD_PAYOUTS() {
        return 'OLD_PAYOUTS';
    }

    static get STORIES() {
        return 'STORIES';
    }

    static get MENU_TRANSLATIONS() {
        return 'MENU_TRANSLATIONS';
    }

    static get options() {
        return {
            ADYEN: this.ADYEN,
            MULTI_MENU: this.MULTI_MENU,
            INTERNAL: this.INTERNAL,
            CENTEGRA: this.CENTEGRA,
            IKENTOO: this.IKENTOO,
            IKENTOO_BETA: this.IKENTOO_BETA,
            COMTREX: this.COMTREX,
            MAILCHIMP: this.MAILCHIMP,
            PAT: this.PAT,
            TOGGLE: this.TOGGLE,
            SAAS: this.SAAS,
            CATEGORY_IMAGE: this.CATEGORY_IMAGE,
            LOYALTY: this.LOYALTY,
            OPENTABLE: this.OPENTABLE,
            FRESHKDS: this.FRESHKDS,
            TISSL: this.TISSL,
            AUTO_APPLY: this.AUTO_APPLY,
            ZONAL: this.ZONAL,
            CATERING: this.CATERING,
            ITEM_IDS: this.ITEM_IDS,
            INVOICE: this.INVOICE,
            BAKERY: this.BAKERY,
            TRANSLATION_EDITOR: this.TRANSLATION_EDITOR,
            STORE_DESIGNER: this.STORE_DESIGNER,
            MEGA_MENU: this.MEGA_MENU,
            DITTOFEED: this.DITTOFEED,
            TRANSLATION_OVERRIDES: this.TRANSLATION_OVERRIDES,
            UBER_DIRECT: this.UBER_DIRECT,
            POINT_ONE: this.POINT_ONE,
            AUTOMATIONS: this.AUTOMATIONS,
            COURSING: this.COURSING,
            PLU: this.PLU,
            API_KEYS: this.API_KEYS,
            VAT_NUMBER: this.VAT_NUMBER,
            OLD_PAYOUTS: this.OLD_PAYOUTS,
            STORIES: this.STORIES,
            MENU_TRANSLATIONS: this.MENU_TRANSLATIONS
        };
    }
}
